import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import Layout from "../components/layout"
import Content from "../components/content"
import SEO from "../components/seo"
import ImageLogos from "../components/imageLogos"
import Form from "../components/form"

import indexStyles from "./index.module.css"

import BonFiscalMobile from "../images/bonfiscal-mobile.jpg"
import ImgContestEnded from "../images/img-ne-vedem.png"

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query ContestFinishedQuery {
      site {
        siteMetadata {
          contestEnded
        }
      }
    }
  `)
  return (
    <Layout>
      <SEO title="Concurs" />
      <Content theme="top">
        <ImageLogos />
      </Content>
      <Content theme="bottom">
        <div className={indexStyles.colWrp}>
          <img
            className={indexStyles.imgBonMobile}
            src={BonFiscalMobile}
            width="320"
            height="335"
            alt=""
          />
          {data.site.siteMetadata.contestEnded ? (
            <div className={indexStyles.endWrp}>
              <p className={indexStyles.endContestText}>
                Concursul s-a încheiat. <br />
                Mulțumim că ai participat și <br />
                te mai așteptăm pe la Prima!
              </p>
              <img
                className={indexStyles.imgEnded}
                src={ImgContestEnded}
                width="360"
                height="228"
                alt=""
              />
            </div>
          ) : (
            <div className={indexStyles.formWrp}>
              <Form />
            </div>
          )}
        </div>
        <p className={indexStyles.copyText}>
          Prima Market (c) Toate Drepturile Rezervate 2019
        </p>
      </Content>
    </Layout>
  )
}

export default IndexPage
